module.exports = __webpack_public_path__ + "static/media/OM.9444f1b0.webp";